var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Config") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-1432.000000, -429.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Config",
    transform: "translate(1432.000000, 429.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,6.23295556 C7.24766667,6.23295556 6.23333333,7.24823333 6.23333333,8.49962222 C6.23333333,9.75195556 7.24766667,10.7672333 8.5,10.7672333 C9.75233333,10.7672333 10.7666667,9.75195556 10.7666667,8.49962222 C10.7666667,7.24823333 9.75233333,6.23295556 8.5,6.23295556",
    id: "Fill-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1666667,9.5302 L12.4761111,9.5302 C12.3835556,9.88342222 12.2456667,10.2149222 12.0690556,10.5247 L13.1362778,11.5919222 L11.5911667,13.1360889 L10.5239444,12.0688667 C10.2141667,12.2464222 9.88361111,12.3833667 9.52944444,12.4749778 L9.52944444,14.1664778 L7.46961111,14.1664778 L7.46961111,12.4749778 C7.11638889,12.3833667 6.78583333,12.2464222 6.47605556,12.0688667 L5.40883333,13.1360889 L3.86277778,11.5919222 L4.93094444,10.5247 C4.75433333,10.2149222 4.61644444,9.88342222 4.52388889,9.5302 L2.83333333,9.5302 L2.83333333,7.46942222 L4.52388889,7.46942222 C4.61644444,7.1162 4.75433333,6.78658889 4.93094444,6.47586667 L3.86277778,5.40864444 L5.40883333,3.86353333 L6.47605556,4.93075556 C6.78583333,4.7532 7.11638889,4.61625556 7.46961111,4.52464444 L7.46961111,2.83314444 L9.52944444,2.83314444 L9.52944444,4.52464444 C9.88361111,4.61625556 10.2141667,4.7532 10.5239444,4.93075556 L11.5911667,3.86353333 L13.1362778,5.40864444 L12.0690556,6.47586667 C12.2456667,6.78658889 12.3835556,7.1162 12.4761111,7.46942222 L14.1666667,7.46942222 L14.1666667,9.5302 Z M15.1111111,-0.000188888889 L1.88888889,-0.000188888889 C0.846222222,-0.000188888889 0,0.846033333 0,1.8887 L0,15.1109222 C0,16.1545333 0.846222222,16.9998111 1.88888889,16.9998111 L15.1111111,16.9998111 C16.1537778,16.9998111 17,16.1545333 17,15.1109222 L17,1.8887 C17,0.846033333 16.1537778,-0.000188888889 15.1111111,-0.000188888889 L15.1111111,-0.000188888889 Z",
    id: "Fill-60"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.9965737fe67e45434ae883560087697b.svg";
export { ForwardRef as ReactComponent };